import { useQuery } from '@tanstack/react-query';

import { getDenominationsTypes } from '../functions/denomination';

export const useGetDenominationsTypes = () =>
  useQuery({
    queryKey: ['get-denominations-types'],
    queryFn: () => getDenominationsTypes()
  });
